/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: checkout/checkout_service.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./checkout";
import * as dependency_2 from "./../payments/payments";
import * as dependency_3 from "./../google/protobuf/timestamp";
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
import * as grpc_web_1 from "grpc-web";
export namespace checkout.v1 {
    export enum ErrorFinalizeUpgradePlan {
        ERROR_UPGRADE_PLAN_UNSPECIFIED = 0,
        ERROR_UPGRADE_PLAN_WALLET_IS_EMPTY = 1
    }
    export class ValidateCouponRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            checkoutId?: string;
            code?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("checkoutId" in data && data.checkoutId != undefined) {
                    this.checkoutId = data.checkoutId;
                }
                if ("code" in data && data.code != undefined) {
                    this.code = data.code;
                }
            }
        }
        get checkoutId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set checkoutId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get code() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set code(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            checkoutId?: string;
            code?: string;
        }): ValidateCouponRequest {
            const message = new ValidateCouponRequest({});
            if (data.checkoutId != null) {
                message.checkoutId = data.checkoutId;
            }
            if (data.code != null) {
                message.code = data.code;
            }
            return message;
        }
        toObject() {
            const data: {
                checkoutId?: string;
                code?: string;
            } = {};
            if (this.checkoutId != null) {
                data.checkoutId = this.checkoutId;
            }
            if (this.code != null) {
                data.code = this.code;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.checkoutId.length)
                writer.writeString(1, this.checkoutId);
            if (this.code.length)
                writer.writeString(2, this.code);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ValidateCouponRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ValidateCouponRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.checkoutId = reader.readString();
                        break;
                    case 2:
                        message.code = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ValidateCouponRequest {
            return ValidateCouponRequest.deserialize(bytes);
        }
    }
    export class ValidateCouponResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            isValid?: boolean;
            discountAppliedAmount?: number;
            finalAmount?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("isValid" in data && data.isValid != undefined) {
                    this.isValid = data.isValid;
                }
                if ("discountAppliedAmount" in data && data.discountAppliedAmount != undefined) {
                    this.discountAppliedAmount = data.discountAppliedAmount;
                }
                if ("finalAmount" in data && data.finalAmount != undefined) {
                    this.finalAmount = data.finalAmount;
                }
            }
        }
        get isValid() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set isValid(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        get discountAppliedAmount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set discountAppliedAmount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get finalAmount() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set finalAmount(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            isValid?: boolean;
            discountAppliedAmount?: number;
            finalAmount?: number;
        }): ValidateCouponResponse {
            const message = new ValidateCouponResponse({});
            if (data.isValid != null) {
                message.isValid = data.isValid;
            }
            if (data.discountAppliedAmount != null) {
                message.discountAppliedAmount = data.discountAppliedAmount;
            }
            if (data.finalAmount != null) {
                message.finalAmount = data.finalAmount;
            }
            return message;
        }
        toObject() {
            const data: {
                isValid?: boolean;
                discountAppliedAmount?: number;
                finalAmount?: number;
            } = {};
            if (this.isValid != null) {
                data.isValid = this.isValid;
            }
            if (this.discountAppliedAmount != null) {
                data.discountAppliedAmount = this.discountAppliedAmount;
            }
            if (this.finalAmount != null) {
                data.finalAmount = this.finalAmount;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.isValid != false)
                writer.writeBool(1, this.isValid);
            if (this.discountAppliedAmount != 0)
                writer.writeInt64(2, this.discountAppliedAmount);
            if (this.finalAmount != 0)
                writer.writeInt64(3, this.finalAmount);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ValidateCouponResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ValidateCouponResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.isValid = reader.readBool();
                        break;
                    case 2:
                        message.discountAppliedAmount = reader.readInt64();
                        break;
                    case 3:
                        message.finalAmount = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ValidateCouponResponse {
            return ValidateCouponResponse.deserialize(bytes);
        }
    }
    export class FinalizeCheckoutSessionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            userId?: string;
            paymentType?: dependency_2.payments.v1.PaymentType;
            coupon?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("coupon" in data && data.coupon != undefined) {
                    this.coupon = data.coupon;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get paymentType() {
            return pb_1.Message.getWrapperField(this, dependency_2.payments.v1.PaymentType, 3) as dependency_2.payments.v1.PaymentType;
        }
        set paymentType(value: dependency_2.payments.v1.PaymentType) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasPaymentType() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get coupon() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set coupon(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            sessionId?: string;
            userId?: string;
            paymentType?: ReturnType<typeof dependency_2.payments.v1.PaymentType.prototype.toObject>;
            coupon?: string;
        }): FinalizeCheckoutSessionRequest {
            const message = new FinalizeCheckoutSessionRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.paymentType != null) {
                message.paymentType = dependency_2.payments.v1.PaymentType.fromObject(data.paymentType);
            }
            if (data.coupon != null) {
                message.coupon = data.coupon;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                userId?: string;
                paymentType?: ReturnType<typeof dependency_2.payments.v1.PaymentType.prototype.toObject>;
                coupon?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.toObject();
            }
            if (this.coupon != null) {
                data.coupon = this.coupon;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (this.hasPaymentType)
                writer.writeMessage(3, this.paymentType, () => this.paymentType.serialize(writer));
            if (this.coupon.length)
                writer.writeString(4, this.coupon);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): FinalizeCheckoutSessionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new FinalizeCheckoutSessionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.paymentType, () => message.paymentType = dependency_2.payments.v1.PaymentType.deserialize(reader));
                        break;
                    case 4:
                        message.coupon = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): FinalizeCheckoutSessionRequest {
            return FinalizeCheckoutSessionRequest.deserialize(bytes);
        }
    }
    export class FinalizeCheckoutSessionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[2]];
        constructor(data?: any[] | ({
            paymentView?: dependency_2.payments.v1.PaymentDetails;
            orderId?: string;
            expiresAt?: dependency_3.google.protobuf.Timestamp;
        } & (({
            errorMessage?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("paymentView" in data && data.paymentView != undefined) {
                    this.paymentView = data.paymentView;
                }
                if ("errorMessage" in data && data.errorMessage != undefined) {
                    this.errorMessage = data.errorMessage;
                }
                if ("orderId" in data && data.orderId != undefined) {
                    this.orderId = data.orderId;
                }
                if ("expiresAt" in data && data.expiresAt != undefined) {
                    this.expiresAt = data.expiresAt;
                }
            }
        }
        get paymentView() {
            return pb_1.Message.getWrapperField(this, dependency_2.payments.v1.PaymentDetails, 1) as dependency_2.payments.v1.PaymentDetails;
        }
        set paymentView(value: dependency_2.payments.v1.PaymentDetails) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPaymentView() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get errorMessage() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set errorMessage(value: string) {
            pb_1.Message.setOneofField(this, 2, this.#one_of_decls[0], value);
        }
        get hasErrorMessage() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get orderId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set orderId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get expiresAt() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 4) as dependency_3.google.protobuf.Timestamp;
        }
        set expiresAt(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasExpiresAt() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get _error_message() {
            const cases: {
                [index: number]: "none" | "errorMessage";
            } = {
                0: "none",
                2: "errorMessage"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        static fromObject(data: {
            paymentView?: ReturnType<typeof dependency_2.payments.v1.PaymentDetails.prototype.toObject>;
            errorMessage?: string;
            orderId?: string;
            expiresAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
        }): FinalizeCheckoutSessionResponse {
            const message = new FinalizeCheckoutSessionResponse({});
            if (data.paymentView != null) {
                message.paymentView = dependency_2.payments.v1.PaymentDetails.fromObject(data.paymentView);
            }
            if (data.errorMessage != null) {
                message.errorMessage = data.errorMessage;
            }
            if (data.orderId != null) {
                message.orderId = data.orderId;
            }
            if (data.expiresAt != null) {
                message.expiresAt = dependency_3.google.protobuf.Timestamp.fromObject(data.expiresAt);
            }
            return message;
        }
        toObject() {
            const data: {
                paymentView?: ReturnType<typeof dependency_2.payments.v1.PaymentDetails.prototype.toObject>;
                errorMessage?: string;
                orderId?: string;
                expiresAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.paymentView != null) {
                data.paymentView = this.paymentView.toObject();
            }
            if (this.errorMessage != null) {
                data.errorMessage = this.errorMessage;
            }
            if (this.orderId != null) {
                data.orderId = this.orderId;
            }
            if (this.expiresAt != null) {
                data.expiresAt = this.expiresAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPaymentView)
                writer.writeMessage(1, this.paymentView, () => this.paymentView.serialize(writer));
            if (this.hasErrorMessage)
                writer.writeString(2, this.errorMessage);
            if (this.orderId.length)
                writer.writeString(3, this.orderId);
            if (this.hasExpiresAt)
                writer.writeMessage(4, this.expiresAt, () => this.expiresAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): FinalizeCheckoutSessionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new FinalizeCheckoutSessionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.paymentView, () => message.paymentView = dependency_2.payments.v1.PaymentDetails.deserialize(reader));
                        break;
                    case 2:
                        message.errorMessage = reader.readString();
                        break;
                    case 3:
                        message.orderId = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.expiresAt, () => message.expiresAt = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): FinalizeCheckoutSessionResponse {
            return FinalizeCheckoutSessionResponse.deserialize(bytes);
        }
    }
    export class FinalizeUpgradePlanRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            checkoutId?: string;
            coupon?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("checkoutId" in data && data.checkoutId != undefined) {
                    this.checkoutId = data.checkoutId;
                }
                if ("coupon" in data && data.coupon != undefined) {
                    this.coupon = data.coupon;
                }
            }
        }
        get checkoutId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set checkoutId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get coupon() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set coupon(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            checkoutId?: string;
            coupon?: string;
        }): FinalizeUpgradePlanRequest {
            const message = new FinalizeUpgradePlanRequest({});
            if (data.checkoutId != null) {
                message.checkoutId = data.checkoutId;
            }
            if (data.coupon != null) {
                message.coupon = data.coupon;
            }
            return message;
        }
        toObject() {
            const data: {
                checkoutId?: string;
                coupon?: string;
            } = {};
            if (this.checkoutId != null) {
                data.checkoutId = this.checkoutId;
            }
            if (this.coupon != null) {
                data.coupon = this.coupon;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.checkoutId.length)
                writer.writeString(1, this.checkoutId);
            if (this.coupon.length)
                writer.writeString(2, this.coupon);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): FinalizeUpgradePlanRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new FinalizeUpgradePlanRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.checkoutId = reader.readString();
                        break;
                    case 2:
                        message.coupon = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): FinalizeUpgradePlanRequest {
            return FinalizeUpgradePlanRequest.deserialize(bytes);
        }
    }
    export class FinalizeUpgradePlanResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            errorDetails?: string;
            paymentInfo?: dependency_2.payments.v1.PaymentDetails;
            expiresAt?: dependency_3.google.protobuf.Timestamp;
            amount?: number;
            creditsEndsAt?: dependency_3.google.protobuf.Timestamp;
            creditsEndsInDays?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("errorDetails" in data && data.errorDetails != undefined) {
                    this.errorDetails = data.errorDetails;
                }
                if ("paymentInfo" in data && data.paymentInfo != undefined) {
                    this.paymentInfo = data.paymentInfo;
                }
                if ("expiresAt" in data && data.expiresAt != undefined) {
                    this.expiresAt = data.expiresAt;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("creditsEndsAt" in data && data.creditsEndsAt != undefined) {
                    this.creditsEndsAt = data.creditsEndsAt;
                }
                if ("creditsEndsInDays" in data && data.creditsEndsInDays != undefined) {
                    this.creditsEndsInDays = data.creditsEndsInDays;
                }
            }
        }
        get errorDetails() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set errorDetails(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get paymentInfo() {
            return pb_1.Message.getWrapperField(this, dependency_2.payments.v1.PaymentDetails, 3) as dependency_2.payments.v1.PaymentDetails;
        }
        set paymentInfo(value: dependency_2.payments.v1.PaymentDetails) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasPaymentInfo() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get expiresAt() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 4) as dependency_3.google.protobuf.Timestamp;
        }
        set expiresAt(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasExpiresAt() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get creditsEndsAt() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 6) as dependency_3.google.protobuf.Timestamp;
        }
        set creditsEndsAt(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasCreditsEndsAt() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get creditsEndsInDays() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set creditsEndsInDays(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            errorDetails?: string;
            paymentInfo?: ReturnType<typeof dependency_2.payments.v1.PaymentDetails.prototype.toObject>;
            expiresAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            amount?: number;
            creditsEndsAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            creditsEndsInDays?: number;
        }): FinalizeUpgradePlanResponse {
            const message = new FinalizeUpgradePlanResponse({});
            if (data.errorDetails != null) {
                message.errorDetails = data.errorDetails;
            }
            if (data.paymentInfo != null) {
                message.paymentInfo = dependency_2.payments.v1.PaymentDetails.fromObject(data.paymentInfo);
            }
            if (data.expiresAt != null) {
                message.expiresAt = dependency_3.google.protobuf.Timestamp.fromObject(data.expiresAt);
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.creditsEndsAt != null) {
                message.creditsEndsAt = dependency_3.google.protobuf.Timestamp.fromObject(data.creditsEndsAt);
            }
            if (data.creditsEndsInDays != null) {
                message.creditsEndsInDays = data.creditsEndsInDays;
            }
            return message;
        }
        toObject() {
            const data: {
                errorDetails?: string;
                paymentInfo?: ReturnType<typeof dependency_2.payments.v1.PaymentDetails.prototype.toObject>;
                expiresAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
                amount?: number;
                creditsEndsAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
                creditsEndsInDays?: number;
            } = {};
            if (this.errorDetails != null) {
                data.errorDetails = this.errorDetails;
            }
            if (this.paymentInfo != null) {
                data.paymentInfo = this.paymentInfo.toObject();
            }
            if (this.expiresAt != null) {
                data.expiresAt = this.expiresAt.toObject();
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.creditsEndsAt != null) {
                data.creditsEndsAt = this.creditsEndsAt.toObject();
            }
            if (this.creditsEndsInDays != null) {
                data.creditsEndsInDays = this.creditsEndsInDays;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.errorDetails.length)
                writer.writeString(2, this.errorDetails);
            if (this.hasPaymentInfo)
                writer.writeMessage(3, this.paymentInfo, () => this.paymentInfo.serialize(writer));
            if (this.hasExpiresAt)
                writer.writeMessage(4, this.expiresAt, () => this.expiresAt.serialize(writer));
            if (this.amount != 0)
                writer.writeInt64(5, this.amount);
            if (this.hasCreditsEndsAt)
                writer.writeMessage(6, this.creditsEndsAt, () => this.creditsEndsAt.serialize(writer));
            if (this.creditsEndsInDays != 0)
                writer.writeInt64(7, this.creditsEndsInDays);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): FinalizeUpgradePlanResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new FinalizeUpgradePlanResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 2:
                        message.errorDetails = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.paymentInfo, () => message.paymentInfo = dependency_2.payments.v1.PaymentDetails.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.expiresAt, () => message.expiresAt = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        message.amount = reader.readInt64();
                        break;
                    case 6:
                        reader.readMessage(message.creditsEndsAt, () => message.creditsEndsAt = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        message.creditsEndsInDays = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): FinalizeUpgradePlanResponse {
            return FinalizeUpgradePlanResponse.deserialize(bytes);
        }
    }
    export class WithCustomerInfoRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            customer?: dependency_1.checkout.v1.CustomerInfo;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("customer" in data && data.customer != undefined) {
                    this.customer = data.customer;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get customer() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CustomerInfo, 2) as dependency_1.checkout.v1.CustomerInfo;
        }
        set customer(value: dependency_1.checkout.v1.CustomerInfo) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasCustomer() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            sessionId?: string;
            customer?: ReturnType<typeof dependency_1.checkout.v1.CustomerInfo.prototype.toObject>;
            userId?: string;
        }): WithCustomerInfoRequest {
            const message = new WithCustomerInfoRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.customer != null) {
                message.customer = dependency_1.checkout.v1.CustomerInfo.fromObject(data.customer);
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                customer?: ReturnType<typeof dependency_1.checkout.v1.CustomerInfo.prototype.toObject>;
                userId?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.customer != null) {
                data.customer = this.customer.toObject();
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.hasCustomer)
                writer.writeMessage(2, this.customer, () => this.customer.serialize(writer));
            if (this.userId.length)
                writer.writeString(4, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WithCustomerInfoRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WithCustomerInfoRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.customer, () => message.customer = dependency_1.checkout.v1.CustomerInfo.deserialize(reader));
                        break;
                    case 4:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WithCustomerInfoRequest {
            return WithCustomerInfoRequest.deserialize(bytes);
        }
    }
    export class WithCustomerInfoResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): WithCustomerInfoResponse {
            const message = new WithCustomerInfoResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WithCustomerInfoResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WithCustomerInfoResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WithCustomerInfoResponse {
            return WithCustomerInfoResponse.deserialize(bytes);
        }
    }
    export class LineItemQuantityUpdate extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            itemId?: string;
            quantity?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("itemId" in data && data.itemId != undefined) {
                    this.itemId = data.itemId;
                }
                if ("quantity" in data && data.quantity != undefined) {
                    this.quantity = data.quantity;
                }
            }
        }
        get itemId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set itemId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get quantity() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set quantity(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            itemId?: string;
            quantity?: number;
        }): LineItemQuantityUpdate {
            const message = new LineItemQuantityUpdate({});
            if (data.itemId != null) {
                message.itemId = data.itemId;
            }
            if (data.quantity != null) {
                message.quantity = data.quantity;
            }
            return message;
        }
        toObject() {
            const data: {
                itemId?: string;
                quantity?: number;
            } = {};
            if (this.itemId != null) {
                data.itemId = this.itemId;
            }
            if (this.quantity != null) {
                data.quantity = this.quantity;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.itemId.length)
                writer.writeString(1, this.itemId);
            if (this.quantity != 0)
                writer.writeInt32(2, this.quantity);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LineItemQuantityUpdate {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LineItemQuantityUpdate();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.itemId = reader.readString();
                        break;
                    case 2:
                        message.quantity = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LineItemQuantityUpdate {
            return LineItemQuantityUpdate.deserialize(bytes);
        }
    }
    export class UpdateItemQuantityInSessionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            updates?: LineItemQuantityUpdate[];
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("updates" in data && data.updates != undefined) {
                    this.updates = data.updates;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get updates() {
            return pb_1.Message.getRepeatedWrapperField(this, LineItemQuantityUpdate, 2) as LineItemQuantityUpdate[];
        }
        set updates(value: LineItemQuantityUpdate[]) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            sessionId?: string;
            updates?: ReturnType<typeof LineItemQuantityUpdate.prototype.toObject>[];
            userId?: string;
        }): UpdateItemQuantityInSessionRequest {
            const message = new UpdateItemQuantityInSessionRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.updates != null) {
                message.updates = data.updates.map(item => LineItemQuantityUpdate.fromObject(item));
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                updates?: ReturnType<typeof LineItemQuantityUpdate.prototype.toObject>[];
                userId?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.updates != null) {
                data.updates = this.updates.map((item: LineItemQuantityUpdate) => item.toObject());
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.updates.length)
                writer.writeRepeatedMessage(2, this.updates, (item: LineItemQuantityUpdate) => item.serialize(writer));
            if (this.userId.length)
                writer.writeString(4, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateItemQuantityInSessionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateItemQuantityInSessionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.updates, () => pb_1.Message.addToRepeatedWrapperField(message, 2, LineItemQuantityUpdate.deserialize(reader), LineItemQuantityUpdate));
                        break;
                    case 4:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateItemQuantityInSessionRequest {
            return UpdateItemQuantityInSessionRequest.deserialize(bytes);
        }
    }
    export class UpdateItemQuantityInSessionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): UpdateItemQuantityInSessionResponse {
            const message = new UpdateItemQuantityInSessionResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateItemQuantityInSessionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateItemQuantityInSessionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateItemQuantityInSessionResponse {
            return UpdateItemQuantityInSessionResponse.deserialize(bytes);
        }
    }
    export class ClearSessionItemsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            sessionId?: string;
            userId?: string;
        }): ClearSessionItemsRequest {
            const message = new ClearSessionItemsRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                userId?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.userId.length)
                writer.writeString(3, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClearSessionItemsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClearSessionItemsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 3:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ClearSessionItemsRequest {
            return ClearSessionItemsRequest.deserialize(bytes);
        }
    }
    export class ClearSessionItemsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): ClearSessionItemsResponse {
            const message = new ClearSessionItemsResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClearSessionItemsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClearSessionItemsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ClearSessionItemsResponse {
            return ClearSessionItemsResponse.deserialize(bytes);
        }
    }
    export class RemoveItemFromSessionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            itemId?: string;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("itemId" in data && data.itemId != undefined) {
                    this.itemId = data.itemId;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get itemId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set itemId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            sessionId?: string;
            itemId?: string;
            userId?: string;
        }): RemoveItemFromSessionRequest {
            const message = new RemoveItemFromSessionRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.itemId != null) {
                message.itemId = data.itemId;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                itemId?: string;
                userId?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.itemId != null) {
                data.itemId = this.itemId;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.itemId.length)
                writer.writeString(2, this.itemId);
            if (this.userId.length)
                writer.writeString(4, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RemoveItemFromSessionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RemoveItemFromSessionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        message.itemId = reader.readString();
                        break;
                    case 4:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RemoveItemFromSessionRequest {
            return RemoveItemFromSessionRequest.deserialize(bytes);
        }
    }
    export class RemoveItemFromSessionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): RemoveItemFromSessionResponse {
            const message = new RemoveItemFromSessionResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RemoveItemFromSessionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RemoveItemFromSessionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RemoveItemFromSessionResponse {
            return RemoveItemFromSessionResponse.deserialize(bytes);
        }
    }
    export class AddItemToSessionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessionId?: string;
            itemId?: string;
            priceId?: string;
            quantity?: number;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessionId" in data && data.sessionId != undefined) {
                    this.sessionId = data.sessionId;
                }
                if ("itemId" in data && data.itemId != undefined) {
                    this.itemId = data.itemId;
                }
                if ("priceId" in data && data.priceId != undefined) {
                    this.priceId = data.priceId;
                }
                if ("quantity" in data && data.quantity != undefined) {
                    this.quantity = data.quantity;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get sessionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set sessionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get itemId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set itemId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get priceId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set priceId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get quantity() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set quantity(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        static fromObject(data: {
            sessionId?: string;
            itemId?: string;
            priceId?: string;
            quantity?: number;
            userId?: string;
        }): AddItemToSessionRequest {
            const message = new AddItemToSessionRequest({});
            if (data.sessionId != null) {
                message.sessionId = data.sessionId;
            }
            if (data.itemId != null) {
                message.itemId = data.itemId;
            }
            if (data.priceId != null) {
                message.priceId = data.priceId;
            }
            if (data.quantity != null) {
                message.quantity = data.quantity;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                sessionId?: string;
                itemId?: string;
                priceId?: string;
                quantity?: number;
                userId?: string;
            } = {};
            if (this.sessionId != null) {
                data.sessionId = this.sessionId;
            }
            if (this.itemId != null) {
                data.itemId = this.itemId;
            }
            if (this.priceId != null) {
                data.priceId = this.priceId;
            }
            if (this.quantity != null) {
                data.quantity = this.quantity;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessionId.length)
                writer.writeString(1, this.sessionId);
            if (this.itemId.length)
                writer.writeString(2, this.itemId);
            if (this.priceId.length)
                writer.writeString(3, this.priceId);
            if (this.quantity != 0)
                writer.writeInt32(4, this.quantity);
            if (this.userId.length)
                writer.writeString(6, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AddItemToSessionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AddItemToSessionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.sessionId = reader.readString();
                        break;
                    case 2:
                        message.itemId = reader.readString();
                        break;
                    case 3:
                        message.priceId = reader.readString();
                        break;
                    case 4:
                        message.quantity = reader.readInt32();
                        break;
                    case 6:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AddItemToSessionRequest {
            return AddItemToSessionRequest.deserialize(bytes);
        }
    }
    export class AddItemToSessionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): AddItemToSessionResponse {
            const message = new AddItemToSessionResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AddItemToSessionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AddItemToSessionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AddItemToSessionResponse {
            return AddItemToSessionResponse.deserialize(bytes);
        }
    }
    export class CreateCheckoutSessionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            successUrl?: string;
            cancelUrl?: string;
            currency?: string;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("successUrl" in data && data.successUrl != undefined) {
                    this.successUrl = data.successUrl;
                }
                if ("cancelUrl" in data && data.cancelUrl != undefined) {
                    this.cancelUrl = data.cancelUrl;
                }
                if ("currency" in data && data.currency != undefined) {
                    this.currency = data.currency;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get successUrl() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set successUrl(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get cancelUrl() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set cancelUrl(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get currency() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set currency(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            successUrl?: string;
            cancelUrl?: string;
            currency?: string;
            userId?: string;
        }): CreateCheckoutSessionRequest {
            const message = new CreateCheckoutSessionRequest({});
            if (data.successUrl != null) {
                message.successUrl = data.successUrl;
            }
            if (data.cancelUrl != null) {
                message.cancelUrl = data.cancelUrl;
            }
            if (data.currency != null) {
                message.currency = data.currency;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                successUrl?: string;
                cancelUrl?: string;
                currency?: string;
                userId?: string;
            } = {};
            if (this.successUrl != null) {
                data.successUrl = this.successUrl;
            }
            if (this.cancelUrl != null) {
                data.cancelUrl = this.cancelUrl;
            }
            if (this.currency != null) {
                data.currency = this.currency;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.successUrl.length)
                writer.writeString(1, this.successUrl);
            if (this.cancelUrl.length)
                writer.writeString(2, this.cancelUrl);
            if (this.currency.length)
                writer.writeString(3, this.currency);
            if (this.userId.length)
                writer.writeString(4, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateCheckoutSessionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateCheckoutSessionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.successUrl = reader.readString();
                        break;
                    case 2:
                        message.cancelUrl = reader.readString();
                        break;
                    case 3:
                        message.currency = reader.readString();
                        break;
                    case 4:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateCheckoutSessionRequest {
            return CreateCheckoutSessionRequest.deserialize(bytes);
        }
    }
    export class CreateCheckoutSessionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): CreateCheckoutSessionResponse {
            const message = new CreateCheckoutSessionResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateCheckoutSessionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateCheckoutSessionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateCheckoutSessionResponse {
            return CreateCheckoutSessionResponse.deserialize(bytes);
        }
    }
    export class GetCheckoutSessionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): GetCheckoutSessionRequest {
            const message = new GetCheckoutSessionRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetCheckoutSessionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetCheckoutSessionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetCheckoutSessionRequest {
            return GetCheckoutSessionRequest.deserialize(bytes);
        }
    }
    export class GetCheckoutSessionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): GetCheckoutSessionResponse {
            const message = new GetCheckoutSessionResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetCheckoutSessionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetCheckoutSessionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetCheckoutSessionResponse {
            return GetCheckoutSessionResponse.deserialize(bytes);
        }
    }
    export class CompleteCheckoutSessionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            id?: string;
            userId?: string;
        }): CompleteCheckoutSessionRequest {
            const message = new CompleteCheckoutSessionRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                userId?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.userId.length)
                writer.writeString(3, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CompleteCheckoutSessionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CompleteCheckoutSessionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 3:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CompleteCheckoutSessionRequest {
            return CompleteCheckoutSessionRequest.deserialize(bytes);
        }
    }
    export class PaymentInfo extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            details?: dependency_2.payments.v1.PaymentDetails;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("details" in data && data.details != undefined) {
                    this.details = data.details;
                }
            }
        }
        get details() {
            return pb_1.Message.getWrapperField(this, dependency_2.payments.v1.PaymentDetails, 1) as dependency_2.payments.v1.PaymentDetails;
        }
        set details(value: dependency_2.payments.v1.PaymentDetails) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasDetails() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            details?: ReturnType<typeof dependency_2.payments.v1.PaymentDetails.prototype.toObject>;
        }): PaymentInfo {
            const message = new PaymentInfo({});
            if (data.details != null) {
                message.details = dependency_2.payments.v1.PaymentDetails.fromObject(data.details);
            }
            return message;
        }
        toObject() {
            const data: {
                details?: ReturnType<typeof dependency_2.payments.v1.PaymentDetails.prototype.toObject>;
            } = {};
            if (this.details != null) {
                data.details = this.details.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasDetails)
                writer.writeMessage(1, this.details, () => this.details.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentInfo {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentInfo();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.details, () => message.details = dependency_2.payments.v1.PaymentDetails.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentInfo {
            return PaymentInfo.deserialize(bytes);
        }
    }
    export class CompleteCheckoutSessionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): CompleteCheckoutSessionResponse {
            const message = new CompleteCheckoutSessionResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CompleteCheckoutSessionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CompleteCheckoutSessionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CompleteCheckoutSessionResponse {
            return CompleteCheckoutSessionResponse.deserialize(bytes);
        }
    }
    export class ListCheckoutSessionsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): ListCheckoutSessionsRequest {
            const message = new ListCheckoutSessionsRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListCheckoutSessionsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListCheckoutSessionsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListCheckoutSessionsRequest {
            return ListCheckoutSessionsRequest.deserialize(bytes);
        }
    }
    export class ListCheckoutSessionsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            sessions?: dependency_1.checkout.v1.CheckoutSession[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("sessions" in data && data.sessions != undefined) {
                    this.sessions = data.sessions;
                }
            }
        }
        get sessions() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession[];
        }
        set sessions(value: dependency_1.checkout.v1.CheckoutSession[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            sessions?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>[];
        }): ListCheckoutSessionsResponse {
            const message = new ListCheckoutSessionsResponse({});
            if (data.sessions != null) {
                message.sessions = data.sessions.map(item => dependency_1.checkout.v1.CheckoutSession.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                sessions?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>[];
            } = {};
            if (this.sessions != null) {
                data.sessions = this.sessions.map((item: dependency_1.checkout.v1.CheckoutSession) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.sessions.length)
                writer.writeRepeatedMessage(1, this.sessions, (item: dependency_1.checkout.v1.CheckoutSession) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListCheckoutSessionsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListCheckoutSessionsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.sessions, () => pb_1.Message.addToRepeatedWrapperField(message, 1, dependency_1.checkout.v1.CheckoutSession.deserialize(reader), dependency_1.checkout.v1.CheckoutSession));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListCheckoutSessionsResponse {
            return ListCheckoutSessionsResponse.deserialize(bytes);
        }
    }
    export class CancelCheckoutSessionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): CancelCheckoutSessionRequest {
            const message = new CancelCheckoutSessionRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancelCheckoutSessionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelCheckoutSessionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CancelCheckoutSessionRequest {
            return CancelCheckoutSessionRequest.deserialize(bytes);
        }
    }
    export class CancelCheckoutSessionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): CancelCheckoutSessionResponse {
            const message = new CancelCheckoutSessionResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancelCheckoutSessionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelCheckoutSessionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CancelCheckoutSessionResponse {
            return CancelCheckoutSessionResponse.deserialize(bytes);
        }
    }
    export class RetentionOffer extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            campaignName?: string;
            discountPercent?: number;
            discountMaxCents?: number;
            discountAmountCents?: number;
            discountValidUntil?: dependency_3.google.protobuf.Timestamp;
            subscriptionId?: string;
            currentPlan?: string;
            situation?: string;
            subscriberSince?: dependency_3.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("campaignName" in data && data.campaignName != undefined) {
                    this.campaignName = data.campaignName;
                }
                if ("discountPercent" in data && data.discountPercent != undefined) {
                    this.discountPercent = data.discountPercent;
                }
                if ("discountMaxCents" in data && data.discountMaxCents != undefined) {
                    this.discountMaxCents = data.discountMaxCents;
                }
                if ("discountAmountCents" in data && data.discountAmountCents != undefined) {
                    this.discountAmountCents = data.discountAmountCents;
                }
                if ("discountValidUntil" in data && data.discountValidUntil != undefined) {
                    this.discountValidUntil = data.discountValidUntil;
                }
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("currentPlan" in data && data.currentPlan != undefined) {
                    this.currentPlan = data.currentPlan;
                }
                if ("situation" in data && data.situation != undefined) {
                    this.situation = data.situation;
                }
                if ("subscriberSince" in data && data.subscriberSince != undefined) {
                    this.subscriberSince = data.subscriberSince;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get campaignName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set campaignName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get discountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set discountPercent(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get discountMaxCents() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set discountMaxCents(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get discountAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set discountAmountCents(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get discountValidUntil() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 6) as dependency_3.google.protobuf.Timestamp;
        }
        set discountValidUntil(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasDiscountValidUntil() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get currentPlan() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set currentPlan(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get situation() {
            return pb_1.Message.getFieldWithDefault(this, 9, "") as string;
        }
        set situation(value: string) {
            pb_1.Message.setField(this, 9, value);
        }
        get subscriberSince() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 10) as dependency_3.google.protobuf.Timestamp;
        }
        set subscriberSince(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasSubscriberSince() {
            return pb_1.Message.getField(this, 10) != null;
        }
        static fromObject(data: {
            campaignId?: string;
            campaignName?: string;
            discountPercent?: number;
            discountMaxCents?: number;
            discountAmountCents?: number;
            discountValidUntil?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            subscriptionId?: string;
            currentPlan?: string;
            situation?: string;
            subscriberSince?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
        }): RetentionOffer {
            const message = new RetentionOffer({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.campaignName != null) {
                message.campaignName = data.campaignName;
            }
            if (data.discountPercent != null) {
                message.discountPercent = data.discountPercent;
            }
            if (data.discountMaxCents != null) {
                message.discountMaxCents = data.discountMaxCents;
            }
            if (data.discountAmountCents != null) {
                message.discountAmountCents = data.discountAmountCents;
            }
            if (data.discountValidUntil != null) {
                message.discountValidUntil = dependency_3.google.protobuf.Timestamp.fromObject(data.discountValidUntil);
            }
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.currentPlan != null) {
                message.currentPlan = data.currentPlan;
            }
            if (data.situation != null) {
                message.situation = data.situation;
            }
            if (data.subscriberSince != null) {
                message.subscriberSince = dependency_3.google.protobuf.Timestamp.fromObject(data.subscriberSince);
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                campaignName?: string;
                discountPercent?: number;
                discountMaxCents?: number;
                discountAmountCents?: number;
                discountValidUntil?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
                subscriptionId?: string;
                currentPlan?: string;
                situation?: string;
                subscriberSince?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.campaignName != null) {
                data.campaignName = this.campaignName;
            }
            if (this.discountPercent != null) {
                data.discountPercent = this.discountPercent;
            }
            if (this.discountMaxCents != null) {
                data.discountMaxCents = this.discountMaxCents;
            }
            if (this.discountAmountCents != null) {
                data.discountAmountCents = this.discountAmountCents;
            }
            if (this.discountValidUntil != null) {
                data.discountValidUntil = this.discountValidUntil.toObject();
            }
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.currentPlan != null) {
                data.currentPlan = this.currentPlan;
            }
            if (this.situation != null) {
                data.situation = this.situation;
            }
            if (this.subscriberSince != null) {
                data.subscriberSince = this.subscriberSince.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.campaignName.length)
                writer.writeString(2, this.campaignName);
            if (this.discountPercent != 0)
                writer.writeInt32(3, this.discountPercent);
            if (this.discountMaxCents != 0)
                writer.writeInt64(4, this.discountMaxCents);
            if (this.discountAmountCents != 0)
                writer.writeInt64(5, this.discountAmountCents);
            if (this.hasDiscountValidUntil)
                writer.writeMessage(6, this.discountValidUntil, () => this.discountValidUntil.serialize(writer));
            if (this.subscriptionId.length)
                writer.writeString(7, this.subscriptionId);
            if (this.currentPlan.length)
                writer.writeString(8, this.currentPlan);
            if (this.situation.length)
                writer.writeString(9, this.situation);
            if (this.hasSubscriberSince)
                writer.writeMessage(10, this.subscriberSince, () => this.subscriberSince.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RetentionOffer {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RetentionOffer();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.campaignName = reader.readString();
                        break;
                    case 3:
                        message.discountPercent = reader.readInt32();
                        break;
                    case 4:
                        message.discountMaxCents = reader.readInt64();
                        break;
                    case 5:
                        message.discountAmountCents = reader.readInt64();
                        break;
                    case 6:
                        reader.readMessage(message.discountValidUntil, () => message.discountValidUntil = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        message.subscriptionId = reader.readString();
                        break;
                    case 8:
                        message.currentPlan = reader.readString();
                        break;
                    case 9:
                        message.situation = reader.readString();
                        break;
                    case 10:
                        reader.readMessage(message.subscriberSince, () => message.subscriberSince = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RetentionOffer {
            return RetentionOffer.deserialize(bytes);
        }
    }
    export class CreateRetentionCheckoutRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
            organizationId?: string;
            planId?: string;
            customer?: dependency_1.checkout.v1.CustomerInfo;
            offer?: RetentionOffer;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("customer" in data && data.customer != undefined) {
                    this.customer = data.customer;
                }
                if ("offer" in data && data.offer != undefined) {
                    this.offer = data.offer;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get customer() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CustomerInfo, 4) as dependency_1.checkout.v1.CustomerInfo;
        }
        set customer(value: dependency_1.checkout.v1.CustomerInfo) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasCustomer() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get offer() {
            return pb_1.Message.getWrapperField(this, RetentionOffer, 5) as RetentionOffer;
        }
        set offer(value: RetentionOffer) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasOffer() {
            return pb_1.Message.getField(this, 5) != null;
        }
        static fromObject(data: {
            userId?: string;
            organizationId?: string;
            planId?: string;
            customer?: ReturnType<typeof dependency_1.checkout.v1.CustomerInfo.prototype.toObject>;
            offer?: ReturnType<typeof RetentionOffer.prototype.toObject>;
        }): CreateRetentionCheckoutRequest {
            const message = new CreateRetentionCheckoutRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.customer != null) {
                message.customer = dependency_1.checkout.v1.CustomerInfo.fromObject(data.customer);
            }
            if (data.offer != null) {
                message.offer = RetentionOffer.fromObject(data.offer);
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                organizationId?: string;
                planId?: string;
                customer?: ReturnType<typeof dependency_1.checkout.v1.CustomerInfo.prototype.toObject>;
                offer?: ReturnType<typeof RetentionOffer.prototype.toObject>;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.customer != null) {
                data.customer = this.customer.toObject();
            }
            if (this.offer != null) {
                data.offer = this.offer.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (this.organizationId.length)
                writer.writeString(2, this.organizationId);
            if (this.planId.length)
                writer.writeString(3, this.planId);
            if (this.hasCustomer)
                writer.writeMessage(4, this.customer, () => this.customer.serialize(writer));
            if (this.hasOffer)
                writer.writeMessage(5, this.offer, () => this.offer.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateRetentionCheckoutRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateRetentionCheckoutRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        message.organizationId = reader.readString();
                        break;
                    case 3:
                        message.planId = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.customer, () => message.customer = dependency_1.checkout.v1.CustomerInfo.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.offer, () => message.offer = RetentionOffer.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateRetentionCheckoutRequest {
            return CreateRetentionCheckoutRequest.deserialize(bytes);
        }
    }
    export class CreateRetentionCheckoutResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            session?: dependency_1.checkout.v1.CheckoutSession;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session" in data && data.session != undefined) {
                    this.session = data.session;
                }
            }
        }
        get session() {
            return pb_1.Message.getWrapperField(this, dependency_1.checkout.v1.CheckoutSession, 1) as dependency_1.checkout.v1.CheckoutSession;
        }
        set session(value: dependency_1.checkout.v1.CheckoutSession) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSession() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
        }): CreateRetentionCheckoutResponse {
            const message = new CreateRetentionCheckoutResponse({});
            if (data.session != null) {
                message.session = dependency_1.checkout.v1.CheckoutSession.fromObject(data.session);
            }
            return message;
        }
        toObject() {
            const data: {
                session?: ReturnType<typeof dependency_1.checkout.v1.CheckoutSession.prototype.toObject>;
            } = {};
            if (this.session != null) {
                data.session = this.session.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSession)
                writer.writeMessage(1, this.session, () => this.session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateRetentionCheckoutResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateRetentionCheckoutResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session, () => message.session = dependency_1.checkout.v1.CheckoutSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateRetentionCheckoutResponse {
            return CreateRetentionCheckoutResponse.deserialize(bytes);
        }
    }
    export abstract class UnimplementedCheckoutServiceService {
        static definition = {
            ValidateCoupon: {
                path: "/checkout.v1.CheckoutService/ValidateCoupon",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ValidateCouponRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ValidateCouponRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ValidateCouponResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ValidateCouponResponse.deserialize(new Uint8Array(bytes))
            },
            CreateCheckoutSession: {
                path: "/checkout.v1.CheckoutService/CreateCheckoutSession",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CreateCheckoutSessionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CreateCheckoutSessionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CreateCheckoutSessionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CreateCheckoutSessionResponse.deserialize(new Uint8Array(bytes))
            },
            GetCheckoutSession: {
                path: "/checkout.v1.CheckoutService/GetCheckoutSession",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetCheckoutSessionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetCheckoutSessionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetCheckoutSessionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetCheckoutSessionResponse.deserialize(new Uint8Array(bytes))
            },
            ListCheckoutSessions: {
                path: "/checkout.v1.CheckoutService/ListCheckoutSessions",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListCheckoutSessionsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListCheckoutSessionsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListCheckoutSessionsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListCheckoutSessionsResponse.deserialize(new Uint8Array(bytes))
            },
            CompleteCheckoutSession: {
                path: "/checkout.v1.CheckoutService/CompleteCheckoutSession",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CompleteCheckoutSessionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CompleteCheckoutSessionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CompleteCheckoutSessionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CompleteCheckoutSessionResponse.deserialize(new Uint8Array(bytes))
            },
            FinalizeCheckoutSession: {
                path: "/checkout.v1.CheckoutService/FinalizeCheckoutSession",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: FinalizeCheckoutSessionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => FinalizeCheckoutSessionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: FinalizeCheckoutSessionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => FinalizeCheckoutSessionResponse.deserialize(new Uint8Array(bytes))
            },
            FinalizeUpgradePlan: {
                path: "/checkout.v1.CheckoutService/FinalizeUpgradePlan",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: FinalizeUpgradePlanRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => FinalizeUpgradePlanRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: FinalizeUpgradePlanResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => FinalizeUpgradePlanResponse.deserialize(new Uint8Array(bytes))
            },
            CancelCheckoutSession: {
                path: "/checkout.v1.CheckoutService/CancelCheckoutSession",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CancelCheckoutSessionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CancelCheckoutSessionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CancelCheckoutSessionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CancelCheckoutSessionResponse.deserialize(new Uint8Array(bytes))
            },
            AddItemToSession: {
                path: "/checkout.v1.CheckoutService/AddItemToSession",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: AddItemToSessionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => AddItemToSessionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AddItemToSessionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AddItemToSessionResponse.deserialize(new Uint8Array(bytes))
            },
            RemoveItemFromSession: {
                path: "/checkout.v1.CheckoutService/RemoveItemFromSession",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: RemoveItemFromSessionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => RemoveItemFromSessionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: RemoveItemFromSessionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => RemoveItemFromSessionResponse.deserialize(new Uint8Array(bytes))
            },
            UpdateItemQuantityInSession: {
                path: "/checkout.v1.CheckoutService/UpdateItemQuantityInSession",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdateItemQuantityInSessionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdateItemQuantityInSessionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdateItemQuantityInSessionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdateItemQuantityInSessionResponse.deserialize(new Uint8Array(bytes))
            },
            ClearSessionItems: {
                path: "/checkout.v1.CheckoutService/ClearSessionItems",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ClearSessionItemsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ClearSessionItemsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ClearSessionItemsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ClearSessionItemsResponse.deserialize(new Uint8Array(bytes))
            },
            WithCustomerInfo: {
                path: "/checkout.v1.CheckoutService/WithCustomerInfo",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: WithCustomerInfoRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => WithCustomerInfoRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: WithCustomerInfoResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => WithCustomerInfoResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract ValidateCoupon(call: grpc_1.ServerUnaryCall<ValidateCouponRequest, ValidateCouponResponse>, callback: grpc_1.sendUnaryData<ValidateCouponResponse>): void;
        abstract CreateCheckoutSession(call: grpc_1.ServerUnaryCall<CreateCheckoutSessionRequest, CreateCheckoutSessionResponse>, callback: grpc_1.sendUnaryData<CreateCheckoutSessionResponse>): void;
        abstract GetCheckoutSession(call: grpc_1.ServerUnaryCall<GetCheckoutSessionRequest, GetCheckoutSessionResponse>, callback: grpc_1.sendUnaryData<GetCheckoutSessionResponse>): void;
        abstract ListCheckoutSessions(call: grpc_1.ServerUnaryCall<ListCheckoutSessionsRequest, ListCheckoutSessionsResponse>, callback: grpc_1.sendUnaryData<ListCheckoutSessionsResponse>): void;
        abstract CompleteCheckoutSession(call: grpc_1.ServerUnaryCall<CompleteCheckoutSessionRequest, CompleteCheckoutSessionResponse>, callback: grpc_1.sendUnaryData<CompleteCheckoutSessionResponse>): void;
        abstract FinalizeCheckoutSession(call: grpc_1.ServerUnaryCall<FinalizeCheckoutSessionRequest, FinalizeCheckoutSessionResponse>, callback: grpc_1.sendUnaryData<FinalizeCheckoutSessionResponse>): void;
        abstract FinalizeUpgradePlan(call: grpc_1.ServerUnaryCall<FinalizeUpgradePlanRequest, FinalizeUpgradePlanResponse>, callback: grpc_1.sendUnaryData<FinalizeUpgradePlanResponse>): void;
        abstract CancelCheckoutSession(call: grpc_1.ServerUnaryCall<CancelCheckoutSessionRequest, CancelCheckoutSessionResponse>, callback: grpc_1.sendUnaryData<CancelCheckoutSessionResponse>): void;
        abstract AddItemToSession(call: grpc_1.ServerUnaryCall<AddItemToSessionRequest, AddItemToSessionResponse>, callback: grpc_1.sendUnaryData<AddItemToSessionResponse>): void;
        abstract RemoveItemFromSession(call: grpc_1.ServerUnaryCall<RemoveItemFromSessionRequest, RemoveItemFromSessionResponse>, callback: grpc_1.sendUnaryData<RemoveItemFromSessionResponse>): void;
        abstract UpdateItemQuantityInSession(call: grpc_1.ServerUnaryCall<UpdateItemQuantityInSessionRequest, UpdateItemQuantityInSessionResponse>, callback: grpc_1.sendUnaryData<UpdateItemQuantityInSessionResponse>): void;
        abstract ClearSessionItems(call: grpc_1.ServerUnaryCall<ClearSessionItemsRequest, ClearSessionItemsResponse>, callback: grpc_1.sendUnaryData<ClearSessionItemsResponse>): void;
        abstract WithCustomerInfo(call: grpc_1.ServerUnaryCall<WithCustomerInfoRequest, WithCustomerInfoResponse>, callback: grpc_1.sendUnaryData<WithCustomerInfoResponse>): void;
    }
    export class CheckoutServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static ValidateCoupon = new grpc_web_1.MethodDescriptor<ValidateCouponRequest, ValidateCouponResponse>("/checkout.v1.CheckoutService/ValidateCoupon", grpc_web_1.MethodType.UNARY, ValidateCouponRequest, ValidateCouponResponse, (message: ValidateCouponRequest) => message.serialize(), ValidateCouponResponse.deserialize);
        ValidateCoupon(message: ValidateCouponRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ValidateCouponRequest, ValidateCouponResponse>(this._address + "/checkout.v1.CheckoutService/ValidateCoupon", message, metadata || {}, CheckoutServiceClient.ValidateCoupon);
        }
        private static CreateCheckoutSession = new grpc_web_1.MethodDescriptor<CreateCheckoutSessionRequest, CreateCheckoutSessionResponse>("/checkout.v1.CheckoutService/CreateCheckoutSession", grpc_web_1.MethodType.UNARY, CreateCheckoutSessionRequest, CreateCheckoutSessionResponse, (message: CreateCheckoutSessionRequest) => message.serialize(), CreateCheckoutSessionResponse.deserialize);
        CreateCheckoutSession(message: CreateCheckoutSessionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CreateCheckoutSessionRequest, CreateCheckoutSessionResponse>(this._address + "/checkout.v1.CheckoutService/CreateCheckoutSession", message, metadata || {}, CheckoutServiceClient.CreateCheckoutSession);
        }
        private static GetCheckoutSession = new grpc_web_1.MethodDescriptor<GetCheckoutSessionRequest, GetCheckoutSessionResponse>("/checkout.v1.CheckoutService/GetCheckoutSession", grpc_web_1.MethodType.UNARY, GetCheckoutSessionRequest, GetCheckoutSessionResponse, (message: GetCheckoutSessionRequest) => message.serialize(), GetCheckoutSessionResponse.deserialize);
        GetCheckoutSession(message: GetCheckoutSessionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetCheckoutSessionRequest, GetCheckoutSessionResponse>(this._address + "/checkout.v1.CheckoutService/GetCheckoutSession", message, metadata || {}, CheckoutServiceClient.GetCheckoutSession);
        }
        private static ListCheckoutSessions = new grpc_web_1.MethodDescriptor<ListCheckoutSessionsRequest, ListCheckoutSessionsResponse>("/checkout.v1.CheckoutService/ListCheckoutSessions", grpc_web_1.MethodType.UNARY, ListCheckoutSessionsRequest, ListCheckoutSessionsResponse, (message: ListCheckoutSessionsRequest) => message.serialize(), ListCheckoutSessionsResponse.deserialize);
        ListCheckoutSessions(message: ListCheckoutSessionsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListCheckoutSessionsRequest, ListCheckoutSessionsResponse>(this._address + "/checkout.v1.CheckoutService/ListCheckoutSessions", message, metadata || {}, CheckoutServiceClient.ListCheckoutSessions);
        }
        private static CompleteCheckoutSession = new grpc_web_1.MethodDescriptor<CompleteCheckoutSessionRequest, CompleteCheckoutSessionResponse>("/checkout.v1.CheckoutService/CompleteCheckoutSession", grpc_web_1.MethodType.UNARY, CompleteCheckoutSessionRequest, CompleteCheckoutSessionResponse, (message: CompleteCheckoutSessionRequest) => message.serialize(), CompleteCheckoutSessionResponse.deserialize);
        CompleteCheckoutSession(message: CompleteCheckoutSessionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CompleteCheckoutSessionRequest, CompleteCheckoutSessionResponse>(this._address + "/checkout.v1.CheckoutService/CompleteCheckoutSession", message, metadata || {}, CheckoutServiceClient.CompleteCheckoutSession);
        }
        private static FinalizeCheckoutSession = new grpc_web_1.MethodDescriptor<FinalizeCheckoutSessionRequest, FinalizeCheckoutSessionResponse>("/checkout.v1.CheckoutService/FinalizeCheckoutSession", grpc_web_1.MethodType.UNARY, FinalizeCheckoutSessionRequest, FinalizeCheckoutSessionResponse, (message: FinalizeCheckoutSessionRequest) => message.serialize(), FinalizeCheckoutSessionResponse.deserialize);
        FinalizeCheckoutSession(message: FinalizeCheckoutSessionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<FinalizeCheckoutSessionRequest, FinalizeCheckoutSessionResponse>(this._address + "/checkout.v1.CheckoutService/FinalizeCheckoutSession", message, metadata || {}, CheckoutServiceClient.FinalizeCheckoutSession);
        }
        private static FinalizeUpgradePlan = new grpc_web_1.MethodDescriptor<FinalizeUpgradePlanRequest, FinalizeUpgradePlanResponse>("/checkout.v1.CheckoutService/FinalizeUpgradePlan", grpc_web_1.MethodType.UNARY, FinalizeUpgradePlanRequest, FinalizeUpgradePlanResponse, (message: FinalizeUpgradePlanRequest) => message.serialize(), FinalizeUpgradePlanResponse.deserialize);
        FinalizeUpgradePlan(message: FinalizeUpgradePlanRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<FinalizeUpgradePlanRequest, FinalizeUpgradePlanResponse>(this._address + "/checkout.v1.CheckoutService/FinalizeUpgradePlan", message, metadata || {}, CheckoutServiceClient.FinalizeUpgradePlan);
        }
        private static CancelCheckoutSession = new grpc_web_1.MethodDescriptor<CancelCheckoutSessionRequest, CancelCheckoutSessionResponse>("/checkout.v1.CheckoutService/CancelCheckoutSession", grpc_web_1.MethodType.UNARY, CancelCheckoutSessionRequest, CancelCheckoutSessionResponse, (message: CancelCheckoutSessionRequest) => message.serialize(), CancelCheckoutSessionResponse.deserialize);
        CancelCheckoutSession(message: CancelCheckoutSessionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CancelCheckoutSessionRequest, CancelCheckoutSessionResponse>(this._address + "/checkout.v1.CheckoutService/CancelCheckoutSession", message, metadata || {}, CheckoutServiceClient.CancelCheckoutSession);
        }
        private static AddItemToSession = new grpc_web_1.MethodDescriptor<AddItemToSessionRequest, AddItemToSessionResponse>("/checkout.v1.CheckoutService/AddItemToSession", grpc_web_1.MethodType.UNARY, AddItemToSessionRequest, AddItemToSessionResponse, (message: AddItemToSessionRequest) => message.serialize(), AddItemToSessionResponse.deserialize);
        AddItemToSession(message: AddItemToSessionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<AddItemToSessionRequest, AddItemToSessionResponse>(this._address + "/checkout.v1.CheckoutService/AddItemToSession", message, metadata || {}, CheckoutServiceClient.AddItemToSession);
        }
        private static RemoveItemFromSession = new grpc_web_1.MethodDescriptor<RemoveItemFromSessionRequest, RemoveItemFromSessionResponse>("/checkout.v1.CheckoutService/RemoveItemFromSession", grpc_web_1.MethodType.UNARY, RemoveItemFromSessionRequest, RemoveItemFromSessionResponse, (message: RemoveItemFromSessionRequest) => message.serialize(), RemoveItemFromSessionResponse.deserialize);
        RemoveItemFromSession(message: RemoveItemFromSessionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<RemoveItemFromSessionRequest, RemoveItemFromSessionResponse>(this._address + "/checkout.v1.CheckoutService/RemoveItemFromSession", message, metadata || {}, CheckoutServiceClient.RemoveItemFromSession);
        }
        private static UpdateItemQuantityInSession = new grpc_web_1.MethodDescriptor<UpdateItemQuantityInSessionRequest, UpdateItemQuantityInSessionResponse>("/checkout.v1.CheckoutService/UpdateItemQuantityInSession", grpc_web_1.MethodType.UNARY, UpdateItemQuantityInSessionRequest, UpdateItemQuantityInSessionResponse, (message: UpdateItemQuantityInSessionRequest) => message.serialize(), UpdateItemQuantityInSessionResponse.deserialize);
        UpdateItemQuantityInSession(message: UpdateItemQuantityInSessionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdateItemQuantityInSessionRequest, UpdateItemQuantityInSessionResponse>(this._address + "/checkout.v1.CheckoutService/UpdateItemQuantityInSession", message, metadata || {}, CheckoutServiceClient.UpdateItemQuantityInSession);
        }
        private static ClearSessionItems = new grpc_web_1.MethodDescriptor<ClearSessionItemsRequest, ClearSessionItemsResponse>("/checkout.v1.CheckoutService/ClearSessionItems", grpc_web_1.MethodType.UNARY, ClearSessionItemsRequest, ClearSessionItemsResponse, (message: ClearSessionItemsRequest) => message.serialize(), ClearSessionItemsResponse.deserialize);
        ClearSessionItems(message: ClearSessionItemsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ClearSessionItemsRequest, ClearSessionItemsResponse>(this._address + "/checkout.v1.CheckoutService/ClearSessionItems", message, metadata || {}, CheckoutServiceClient.ClearSessionItems);
        }
        private static WithCustomerInfo = new grpc_web_1.MethodDescriptor<WithCustomerInfoRequest, WithCustomerInfoResponse>("/checkout.v1.CheckoutService/WithCustomerInfo", grpc_web_1.MethodType.UNARY, WithCustomerInfoRequest, WithCustomerInfoResponse, (message: WithCustomerInfoRequest) => message.serialize(), WithCustomerInfoResponse.deserialize);
        WithCustomerInfo(message: WithCustomerInfoRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<WithCustomerInfoRequest, WithCustomerInfoResponse>(this._address + "/checkout.v1.CheckoutService/WithCustomerInfo", message, metadata || {}, CheckoutServiceClient.WithCustomerInfo);
        }
    }
    export abstract class UnimplementedCheckoutInternalServiceService {
        static definition = {
            CreateRetentionCheckout: {
                path: "/checkout.v1.CheckoutInternalService/CreateRetentionCheckout",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CreateRetentionCheckoutRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CreateRetentionCheckoutRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CreateRetentionCheckoutResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CreateRetentionCheckoutResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract CreateRetentionCheckout(call: grpc_1.ServerUnaryCall<CreateRetentionCheckoutRequest, CreateRetentionCheckoutResponse>, callback: grpc_1.sendUnaryData<CreateRetentionCheckoutResponse>): void;
    }
    export class CheckoutInternalServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static CreateRetentionCheckout = new grpc_web_1.MethodDescriptor<CreateRetentionCheckoutRequest, CreateRetentionCheckoutResponse>("/checkout.v1.CheckoutInternalService/CreateRetentionCheckout", grpc_web_1.MethodType.UNARY, CreateRetentionCheckoutRequest, CreateRetentionCheckoutResponse, (message: CreateRetentionCheckoutRequest) => message.serialize(), CreateRetentionCheckoutResponse.deserialize);
        CreateRetentionCheckout(message: CreateRetentionCheckoutRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CreateRetentionCheckoutRequest, CreateRetentionCheckoutResponse>(this._address + "/checkout.v1.CheckoutInternalService/CreateRetentionCheckout", message, metadata || {}, CheckoutInternalServiceClient.CreateRetentionCheckout);
        }
    }
}
